import React from 'react';
import PropTypes from 'prop-types';
import RoutedHeader from '../Header';
import BaseFilteredList from '../BaseFilteredList';
import FilterItemType from '../BaseFilteredList/FilterItemType';
import FilterDateRange from '../BaseFilteredList/FilterDateRange';

const AccountDocs = ({
  children,
  itemTypeOpts,
  onItemTypeChange,
  itemTypeSelected,
  onFromChange,
  dateMin,
  fromSelected,
  onToChange,
  dateMax,
  toSelected,
  mediaQueryValues,
}) => {
  const filters = [
    {
      Comp: FilterItemType,
      props: {
        onChange: onItemTypeChange,
        itemTypeSelected,
        options: itemTypeOpts,
      },
    },
    {
      Comp: FilterDateRange,
      props: {
        onChange: onItemTypeChange,
        onFromChange,
        min: dateMin,
        fromSelected,
        onToChange,
        max: dateMax,
        toSelected,
      },
    },
  ];
  return (
    <div>
      <RoutedHeader />
      <BaseFilteredList
        listLabel="Statements and Documents"
        filters={filters}
        mediaQueryValues={mediaQueryValues}
      >
        {children}
      </BaseFilteredList>
    </div>
  );
};

AccountDocs.propTypes = {
  itemTypeOpts: PropTypes.arrayOf(PropTypes.string),
  itemTypeSelected: PropTypes.string,
  onItemTypeChange: PropTypes.func,
  dateMin: PropTypes.string,
  fromSelected: PropTypes.string,
  onFromChange: PropTypes.func,
  dateMax: PropTypes.string,
  toSelected: PropTypes.string,
  onToChange: PropTypes.func,
  mediaQueryValues: PropTypes.shape({}),
};

AccountDocs.defaultProps = {
  itemTypeOpts: ['All Documents'],
  itemTypeSelected: 'All Documents',
  onItemTypeChange: () => {},
  dateMin: '',
  fromSelected: '',
  onFromChange: () => {},
  dateMax: '',
  toSelected: '',
  onToChange: () => {},
  mediaQueryValues: {},
};

export default AccountDocs;



// WEBPACK FOOTER //
// ./src/components/AccountDocs/AccountDocs.js